module.exports = {"urlTranslate":{"requestDrawing":"Request Drawing","coil":"Coil","tubeInTube":"Tube In Tube","create":"Create","update":"Update","view":"View","accessory":"Accessory"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/urlTranslate.json
// module id = 930
// module chunks = 108